<template>
    <div
        v-if="isOpen"
        class="fixed inset-0 z-40 bg-slate-800 bg-opacity-50 md:hidden flex items-end"
        @click="$emit('close')"
    >
        <div
            @click.stop
            class="w-full bg-white dark:bg-slate-800 rounded-[24px] flex flex-col items-start px-6 pt-6 pb-12 shadow-[0_1px_3px_0_rgba(0,0,0,0.10),0_1px_2px_0_rgba(0,0,0,0.06)]"
        >
            <div class="flex items-center justify-between w-full mb-4">
                <h3 class="text-slate-800 dark:text-slate-100 text-lg font-medium leading-7">
                    Bonus alert
                </h3>
                <button
                    @click="$emit('close')"
                    class="flex items-center justify-center w-6 h-6 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18 6L6 18M6 6L18 18"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>

            <BonusAlertDropdown
                :programName="programName"
                :email="email"
                :bonusAlertEnabled="bonusAlertEnabled"
                :bonusAlertLoading="bonusAlertLoading"
                variant="mobile-sheet"
                @toggle="$emit('toggle', $event)"
            />
        </div>
    </div>
</template>

<script setup>
import BonusAlertDropdown from './BonusAlertDropdown.vue';

defineProps({
    isOpen: Boolean,
    programName: String,
    email: String,
    bonusAlertEnabled: Boolean,
    bonusAlertLoading: Boolean,
});

defineEmits(['close', 'toggle']);
</script>
